export type LazyMap<T> = { [key: string]: () => T }

export function stripComponent(identifier: string) {
    const match = identifier.match(/(.*?\.[tj]sx?)_.*/)
    if (!match) return identifier
    return match[1]
}

export function warn(message: string, error?: any) {
    if (process.env.NODE_ENV === "test") return
    // tslint:disable-next-line:no-console
    console.log(
        "%c Loader: %c " + message,
        "color: white; font-weight: bold; background-color: #EE4444; border-radius: 5px; padding: 2px 5px",
        "color: #EE4444"
    )
    if (!error) return
    // tslint:disable-next-line:no-console
    console.warn(error)
}

const needle = "Module parse failed: "

/*
Reword error messages like below
```
Module parse failed: 'return' outside of function (11:8)
    You may need an appropriate loader to handle this file type.
    |     render();
    |     {
    |         return React.createElement("div", null, "Hello");
    |     }
    | } undefined undefined
```
*/
export function rewordCompileError(message: string): string {
    if (!message.startsWith(needle)) return message

    const split = message.split("\n")
    const first = split[0]
    if (!first) return message
    const rest = split.slice(2)
    return first.slice(needle.length) + "\n" + rest.join("\n")
}
